import "./pages.css"
import React, { useState, useEffect } from 'react';
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";

const LiveStreaming = () => {
  const [data, setData] = useState([]);
  
  useEffect(() => {
      const fetchClientData = async () => {
          try {
          const querySnapshot = await getDocs(collection(db, "Live Streams"));
          const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setData(documents);
          } catch (error) {
          console.error("Error fetching data: ", error);
          }
      };
  
      fetchClientData();
  }, []);

  return (
    <div>
      <div id="banner"></div>
      <div id="content">
        <div className="row">
          <div className="col-sm-9">
            <h1>RCC Montana Live Streaming</h1>
          </div>
          <div className="col-sm-3 button-side">
            <Link to="/start-stream"><button>Start Streaming</button></Link>
          </div>
        </div>
        <br/>
        <div className="row">
          {data.map((item, index) => (
            <div className="col-sm-3" key={index}>
              <img className="ls-image" src={item.FeaturedImage} width="100%"/>
              <h3 className="ls-title">{item.Title}</h3>
              <p className="ls-meta-data">{item.Date.toDate().toLocaleDateString()} <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dot" viewBox="0 0 16 16">
  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
</svg> {item.Preacher}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LiveStreaming;
